"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DonChuyCuidamosALosQueMasQuieres() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222686" id="obnavljamo-oživljavamo-i-vraćamo-vašu-slobodu-na-kotačima" className="relative overflow-hidden dark bg-background py-16 md:py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <div className="absolute -right-[10%] -top-[10%] h-[60%] w-[50%] rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -bottom-[10%] -left-[10%] h-[50%] w-[40%] rounded-full bg-accent/5 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 lg:col-span-7 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="space-y-4">
              <span className="inline-block rounded-sm bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary font-default">
                ChargeZone Zagreb
              </span>
              <h1 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-[4rem] lg:leading-[1.1] uppercase">
                Obnavljamo, oživljavamo i vraćamo vašu <span className="!text-[hsl(0,0%,100%)]">SLOBODU</span> na kotačima
              </h1>
            </div>
            
            <p className="max-w-2xl text-lg text-muted-foreground md:text-xl leading-relaxed font-sans">
              Munjevito brzi popravci električnih romobila i profesionalna usluga. 
              Specijalizirani smo za napredni servis baterija, BMS dijagnostiku 
              te kompletnu mehaničku i elektroničku obnovu vašeg ljubimca.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-base rounded-sm shadow-lg shadow-primary/20 hover:shadow-primary/30 transition-all bg-primary text-primary-foreground font-sans">
                <Link to="#">
                  <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                  Rezerviraj popravak
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative lg:col-span-5 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="relative mx-auto max-w-[400px] lg:max-w-none">
              {}
              <div className="relative aspect-[3/4] w-full overflow-hidden rounded-sm shadow-2xl border border-border/50">
                <img src="https://charge-zone.com/wp-content/uploads/2026/04/image.jpg" alt="Profesionalna dijagnostika i servis baterija za električne romobile" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
                {}
                <div className="absolute inset-0 rounded-sm ring-1 ring-inset ring-primary/20" />
              </div>

              {}
              <div className="absolute -bottom-8 -left-8 md:-bottom-12 md:-left-12 h-40 w-40 md:h-56 md:w-56 overflow-hidden rounded-sm border-[4px] border-background shadow-2xl">
                <img src="https://charge-zone.com/wp-content/uploads/2026/04/a51b091a-6897-4336-b4f2-17dfe3846313.jpg" alt="Servis električnih romobila ChargeZone radionica" className="h-full w-full object-cover" />
              </div>
              
              {}
              <div className="absolute -right-6 -top-6 -z-10 h-32 w-32 bg-[radial-gradient(var(--color-primary)_1px,transparent_1px)] [background-size:16px_16px] opacity-30" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}